export default __webpack_public_path__ + "static/metamask-c7e5ee84f8026b1b4bd2e441908ec030.png";